<template>
    <section class="panel">
            <header class="panel-heading">
                <h2 class="panel-title">Sala de Juntas</h2>
            </header>
            <div class="panel-body" v-if="isLoading">
                <img src="/assets/images/loading.gif" alt="loading..." />
            </div>
            <div class="panel-body" v-if="!isLoading">
                <div v-for="reservation in reservations" :key="reservation.id" >
                    <h3>Codigo: {{ reservation.referenceCode }} 
                        <span class="badge"> {{formatStatus(reservation.reservationStatus)}}</span></h3>
                    <p class="lead mt-xs"><b>Fecha:</b> {{ formatDate(reservation.startTime) }}  
                                                        {{ formatTime(reservation.startTime) }} 
                                                        - {{ formatTime(reservation.endTime) }}</p>
                    <p class="lead mt-xl mb-xs"><b>Area:</b> {{reservation.meetingRoomSpace}}</p>
                    <p class="lead mt-xl mb-xs"><b>Reservado por:</b>
                        <p v-for="(user, index) in formatOfficeUser(reservation.reservationOwner)" :key="index">
                            {{user}}<br>
                        </p>
                    </p>
                    <hr />
                </div>
            </div>
     </section>        
</template>

<script>
    export default {
        name: 'Reservations',
        data: function () {
            return {
                isLoading : true,
                reservations : {}
            }
        },
        mounted: function(){
            this.$nextTick(function () {
                this.refresh();
            });
        },
        computed: {
            accountId () {
                return this.$store.state.accountId
            }
        },
        methods: {
            formatDate: function (dateString) {
                var date = new Date(dateString);
                // https://www.npmjs.com/package/dateformat
                var dateFormat = require('dateformat');
                return dateFormat(date, "mmmm dS, yyyy");
            },
            formatTime: function (timeString) {
                var time = new Date(timeString);
                // https://www.npmjs.com/package/dateformat
                var dateFormat = require('dateformat');
                return dateFormat(time, "h:MM TT");
            },
            formatOfficeUser: function(reservationOfficeUser){
                var officeUser = new String;
                officeUser = reservationOfficeUser.split(" - ").slice(0,-1);
                return officeUser;
            },
            formatStatus: function (reservationStatus) {
                var status = new String;
                switch (reservationStatus) {
                    case "Active": status= "Activo"; break; 
                    case "Completed": status= "Completado"; break; 
                    case "Cancelled": status= "Cancelado"; break; 
                    default: status= reservationStatus; break; 
                    }
                return status;
            },
            async refresh () {
                var self = this;
                this.isLoading = true;
                const jwtAccessToken = await this.$auth.getTokenSilently();
                const jwtIdToken = (await this.$auth.getIdTokenClaims()).__raw;

                this.axios.get(process.env.VUE_APP_API_PATH + "reservations/list",
                                        {
                            headers: {
                                Authorization: `Bearer ${jwtAccessToken}`,  // send the access token through the 'Authorization' header,
                                IdToken: `${jwtIdToken}`
                            }
                        }
                    ).
                    then(function (response) {
                        //console.debug(response.data);
                        self.reservations = response.data;
                        self.isLoading = false;
                    }, function (error) {
                        self.isLoading = false;
                    });
            }
        }
    }
</script>